import React from 'react';
import {connect} from 'react-redux';
import * as selectors from '../../../application.selectors';

import {Link, withRouter} from 'react-router-dom'
import { getToken } from '../../../token_management';

const ItemLink = ({item}) => item.remote
  ? <a href={`${item.link}?token=${getToken()}`}>{item.caption}</a>
  : <Link to={item.link}>{item.caption}</Link>;

const Item = ({item}) => (
  <div>
    <h3 className="label">
      {item.hasLink && <ItemLink item={item}/>}
      {!item.hasLink && <span>{item.caption}</span>}
    </h3>
    <ul className="depth-1 nav nav-list">
      {item.children.map((child, index) => (
        <li key={index}>
          <ItemLink item={child}/>
        </li>
      ))}
    </ul>
  </div>
);

const Navigation = ({items}) => {
  return (
    <div className="secondary-nav">
      {items.map((item, index) => (
        <Item key={index} item={item}/>
      ))}
    </div>
  );
};

export default withRouter(
  connect(
    (state) => ({
      items: selectors.navigationItems(state),
      fetching: selectors.fetchingNavigation(state)
    })
  )(Navigation)
);


// WEBPACK FOOTER //
// ./src/modules/layout/components/Navigation.js